import React from 'react';
import { theme, commonStyles } from '../styles';
import { projects } from '../data';

const ProjectsPage = ({ isMobile }) => {
  return (
    <section style={{
      ...commonStyles.page,
      ...(isMobile ? commonStyles.pageMobile : {}),
    }}>
      <h1 style={{
        ...commonStyles.pageTitle,
        ...(isMobile ? commonStyles.pageTitleMobile : {}),
      }}>
        Mes Projets
      </h1>
      <p style={{
        ...commonStyles.pageSubtitle,
        ...(isMobile ? commonStyles.pageSubtitleMobile : {}),
      }}>
        Découvrez mes réalisations personnelles et professionnelles
      </p>
      
      <div style={{
        ...styles.projectsGrid,
        gap: isMobile ? '1.25rem' : '2rem',
      }}>
        {projects.map((project, index) => (
          <ProjectCard 
            key={index} 
            project={project} 
            index={index}
            isMobile={isMobile} 
          />
        ))}
      </div>
    </section>
  );
};

const ProjectCard = ({ project, index, isMobile }) => (
  <div 
    style={{
      ...styles.projectCard,
      padding: isMobile ? '1.25rem' : '2rem',
      animationDelay: `${index * 0.1}s`,
    }}
  >
    {/* Accent bar */}
    <div style={{
      ...styles.projectAccent,
      background: project.color,
    }} />
    
    {/* Title */}
    <h3 style={{
      ...styles.projectTitle,
      fontSize: isMobile ? '1.1rem' : '1.25rem',
    }}>
      {project.title}
    </h3>
    
    {/* Description */}
    <p style={{
      ...styles.projectDescription,
      fontSize: isMobile ? '0.85rem' : '0.95rem',
    }}>
      {project.description}
    </p>
    
    {/* Technologies */}
    <div style={styles.projectTech}>
      {project.technologies.map((tech, i) => (
        <span 
          key={i} 
          style={{
            ...styles.techTag,
            borderColor: project.color,
            color: project.color,
            padding: isMobile ? '0.3rem 0.6rem' : '0.4rem 0.8rem',
            fontSize: isMobile ? '0.7rem' : '0.8rem',
          }}
        >
          {tech}
        </span>
      ))}
    </div>
    
    {/* Optional: Links */}
    {(project.github || project.demo) && (
      <div style={styles.projectLinks}>
        {project.github && (
          <a 
            href={project.github}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              ...styles.projectLink,
              color: project.color,
            }}
          >
            GitHub →
          </a>
        )}
        {project.demo && (
          <a 
            href={project.demo}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              ...styles.projectLink,
              color: project.color,
            }}
          >
            Demo →
          </a>
        )}
      </div>
    )}
  </div>
);

const styles = {
  projectsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
  },
  projectCard: {
    background: theme.colors.backgroundCard,
    borderRadius: '16px',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    position: 'relative',
    overflow: 'hidden',
    transition: theme.transition.normal,
    animation: 'fadeInUp 0.5s ease backwards',
  },
  projectAccent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
  },
  projectTitle: {
    fontWeight: '600',
    color: theme.colors.text,
    marginBottom: '1rem',
  },
  projectDescription: {
    color: theme.colors.textMuted,
    lineHeight: '1.7',
    marginBottom: '1.5rem',
  },
  projectTech: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
  },
  techTag: {
    borderRadius: '6px',
    fontWeight: '500',
    border: '1px solid',
    background: 'transparent',
  },
  projectLinks: {
    display: 'flex',
    gap: '1rem',
    marginTop: '1.5rem',
    paddingTop: '1rem',
    borderTop: '1px solid rgba(255, 255, 255, 0.05)',
  },
  projectLink: {
    textDecoration: 'none',
    fontWeight: '500',
    fontSize: '0.9rem',
    transition: theme.transition.normal,
  },
};

export default ProjectsPage;
